// @ts-check
import { onDomReady } from '../utils/dom';

/**
 * „Kopieren"-Schalter: Element mit data-copy="<Text>" kopiert den Text in die Zwischenablage und zeigt 1,8 s die Klasse
 * .copied; mit data-copy-label wird zusätzlich der Text getauscht. Referenz: C Festival 2027, Bankverbindung (IBAN/Verwendungszweck).
 */

/**
 * @param {string} text
 * @returns {boolean}
 */
function legacyCopy(text) {
    const area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.append(area);
    area.select();

    let ok = false;
    try {
        ok = document.execCommand('copy');
    } finally {
        area.remove();
    }

    return ok;
}

/**
 * @param {HTMLElement} button
 */
async function copy(button) {
    const text = button.dataset.copy ?? '';
    // Ohne data-copy-label bleibt der Text stehen (z. B. die IBAN selbst als Schalter) – Rückmeldung dann nur über .copied (CSS)
    const label = button.dataset.copyLabel;
    const original = button.textContent ?? '';

    try {
        if (navigator.clipboard) {
            await navigator.clipboard.writeText(text);
        } else if (!legacyCopy(text)) {
            // Clipboard API gibt es nur im sicheren Kontext (https) – Fallback für http/ältere Browser
            throw new Error('execCommand(copy) fehlgeschlagen');
        }
    } catch (error) {
        console.warn('Zwischenablage nicht verfügbar', error);
        return;
    }

    if (label) {
        button.textContent = label;
        button.setAttribute('aria-live', 'polite');
    }
    button.classList.add('copied');

    window.setTimeout(() => {
        if (label) button.textContent = original;
        button.classList.remove('copied');
    }, 1800);
}

onDomReady(() => {
    for (const button of document.querySelectorAll('[data-copy]')) {
        if (!(button instanceof HTMLElement)) continue;

        button.addEventListener('click', (event) => {
            event.preventDefault();
            copy(button);
        });
    }
});
